import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'transfer/utils/p2p-connect'
import content from 'pp-react-l10n'
import { Icon } from '@paypalcorp/pp-react'
const i18n = content('transfer/inc/note')

const STYLES = {
  errorField: {
    textAlign: 'left',
    paddingLeft: '10px',
  },
  errorText: {
    color: '#687173',
    fontSize: '14px',
  },
  criticalIcon: {
    color: '#D20000',
    marginRight: '0.75rem',
    verticalAlign: 'bottom',
  },
}

export function NoteMaxCharLimitError(props) {
  const errorText = 'note.errorMaxCharacterLimit'

  if (!props.showNoteMaxCharLimitError) {
    return null
  }

  return (
    <div style={{ ...STYLES.errorField }}>
      <span>
        <Icon
          name="critical-alt"
          size="xs"
          style={{ ...STYLES.criticalIcon }}
        />
        <span
          role="alert"
          data-testid="note-field-error"
          style={STYLES.errorText}
        >
          {i18n(errorText)}
        </span>
      </span>
    </div>
  )
}

NoteMaxCharLimitError.propTypes = {
  showNoteMaxCharLimitError: PropTypes.bool,
}

export default connect(({ external }) => ({
  showNoteMaxCharLimitError: external.showNoteMaxCharLimitError,
}))(NoteMaxCharLimitError)
